import React from 'react'

const Machine_Learning = () => {
  return (
    <div>
        {/* collapseFiftyTwo */}
        <div className="accordion-item mb-2">
        <h2 className="accordion-header" id="headingFiftyTwo">
            <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyTwo" aria-expanded="false" aria-controls="collapseFiftyTwo">
            Machine Learning
            <span className="toggle-icon ms-auto"></span>
            </button>
        </h2>
        <div id="collapseFiftyTwo" className="accordion-collapse collapse" aria-labelledby="headingFiftyTwo" data-bs-parent="#accordionCourses">
            <div className="accordion-body overflow-auto" style={{ maxHeight: '300px' }}>
            <strong>Module 1: Supervised Learning</strong>
            <ul>
                <li>Linear Regression
                    <ul>
                    <li>Linear Equation</li>
                    <li>Slope</li>
                    <li>Intercept</li>
                    <li>R square value</li>
                    </ul>
                </li>
                <li>Logistic Regression
                    <ul>
                    <li>ODDS ratio</li>
                    <li>Probability of success</li>
                    <li>Probability of failure</li>
                    <li>ROC curve</li>
                    <li>Bias Variance Tradeoff</li>
                    </ul>
                </li>
            </ul>

            <strong>Module 2: Unsupervised Learning:</strong>
            <ul>
                <li>K-Means</li>
                <li>K-Means ++</li>
                <li>Hierarchical Clustering</li>
            </ul>

            <strong>Module 3: SVM</strong>
            <ul>
                <li>Support Vectors</li>
                <li>Hyperplanes</li>
                <li>2-D Case</li>
                <li>Linear Hyperplane</li>
            </ul>

            <strong>Module 4: SVM Kernal</strong>
            <ul>
                <li>Linear</li>
                <li>Radial</li>
                <li>polynomial</li>
            </ul>

            <strong>Module 5: Other Machine Learning Algorithms</strong>
            <ul>
                <li>K - Nearest Neighbour</li>
                <li>Naïve Bayes Classifier</li>
                <li>Decision Tree - CART</li>
                <li>Decision Tree - C50</li>
                <li>Random Forest</li>
            </ul>

            </div>
        </div>
        </div>

    </div>
  )
}

export default Machine_Learning